// extracted by mini-css-extract-plugin
export var actions = "starter-profile-module--actions--P4RJM";
export var backButton = "starter-profile-module--backButton--h0RNl";
export var card = "starter-profile-module--card--SMUpS";
export var colorPreferenceActions = "starter-profile-module--colorPreferenceActions--STurj";
export var colorPreferenceBlock = "starter-profile-module--colorPreferenceBlock--CzApB";
export var colorPreferenceButton = "starter-profile-module--colorPreferenceButton--oWNG7";
export var colorPreferenceCard = "starter-profile-module--colorPreferenceCard--ocDSy";
export var colorPreferenceDisliked = "starter-profile-module--colorPreferenceDisliked--k3tIF";
export var colorPreferenceGrid = "starter-profile-module--colorPreferenceGrid--xmcvP";
export var colorPreferenceHeader = "starter-profile-module--colorPreferenceHeader--Xp4Pg";
export var colorPreferenceImage = "starter-profile-module--colorPreferenceImage--myReK";
export var colorPreferenceIntro = "starter-profile-module--colorPreferenceIntro--5Ngk1";
export var colorPreferenceLabel = "starter-profile-module--colorPreferenceLabel--L6Gsf";
export var colorPreferenceLiked = "starter-profile-module--colorPreferenceLiked--X1Q3E";
export var completion = "starter-profile-module--completion--gSff9";
export var completionCopy = "starter-profile-module--completionCopy--BKwJW";
export var completionList = "starter-profile-module--completionList--QX4gs";
export var completionMark = "starter-profile-module--completionMark--CE5xi";
export var completionTitle = "starter-profile-module--completionTitle--5XgJ6";
export var dashboardLink = "starter-profile-module--dashboardLink--g3OS8";
export var errorText = "starter-profile-module--errorText--cvDEk";
export var eyebrow = "starter-profile-module--eyebrow--HvhuK";
export var generatorButton = "starter-profile-module--generatorButton--qqfWM";
export var header = "starter-profile-module--header--CFzy0";
export var headerCopy = "starter-profile-module--headerCopy--YEkjK";
export var headerTitle = "starter-profile-module--headerTitle--2i7UZ";
export var introBottomCta = "starter-profile-module--introBottomCta--hEBYh";
export var introCopy = "starter-profile-module--introCopy--bJ65J";
export var introCta = "starter-profile-module--introCta--PFO6l";
export var introCtaArrow = "starter-profile-module--introCtaArrow--qvtJq";
export var introHeroGrid = "starter-profile-module--introHeroGrid--GhVnx";
export var introHeroImage = "starter-profile-module--introHeroImage--0sl0B";
export var introHighlight = "starter-profile-module--introHighlight--oh-qC";
export var introHighlights = "starter-profile-module--introHighlights--Kipv3";
export var introImageBadge = "starter-profile-module--introImageBadge--cj1FL";
export var introKicker = "starter-profile-module--introKicker--2tEp7";
export var introLead = "starter-profile-module--introLead--cCL81";
export var introMicrocopy = "starter-profile-module--introMicrocopy--UYJfs";
export var introPage = "starter-profile-module--introPage--FVkVX";
export var introPreview = "starter-profile-module--introPreview--J0jnQ";
export var introPreviewBody = "starter-profile-module--introPreviewBody--QDx8-";
export var introPreviewCard = "starter-profile-module--introPreviewCard--FtyYO";
export var introPreviewCopy = "starter-profile-module--introPreviewCopy--rIUkf";
export var introPreviewGrid = "starter-profile-module--introPreviewGrid--eh7tY";
export var introPreviewHeading = "starter-profile-module--introPreviewHeading--rMEF1";
export var introPreviewImage = "starter-profile-module--introPreviewImage--hwlJD";
export var introPreviewNumber = "starter-profile-module--introPreviewNumber--Os1Dg";
export var introShell = "starter-profile-module--introShell--QjzFZ";
export var introTitle = "starter-profile-module--introTitle--pez-C";
export var introTrustIcon = "starter-profile-module--introTrustIcon--t8cS8";
export var introTrustItem = "starter-profile-module--introTrustItem--yPcE4";
export var introTrustStrip = "starter-profile-module--introTrustStrip--3vTGK";
export var introVisual = "starter-profile-module--introVisual--TMN27";
export var nextButton = "starter-profile-module--nextButton--GoC8q";
export var noPreferenceActions = "starter-profile-module--noPreferenceActions--F+htR";
export var noPreferenceButton = "starter-profile-module--noPreferenceButton--ltSps";
export var noPreferenceSelected = "starter-profile-module--noPreferenceSelected--MwIbF";
export var option = "starter-profile-module--option--cZPLh";
export var optionCheck = "starter-profile-module--optionCheck--PvisF";
export var optionImage = "starter-profile-module--optionImage--njuKc";
export var optionSelected = "starter-profile-module--optionSelected--r7E8p";
export var options = "starter-profile-module--options--JUgt2";
export var page = "starter-profile-module--page--nZimN";
export var progressBar = "starter-profile-module--progressBar--vwd9v";
export var progressMeta = "starter-profile-module--progressMeta--ITNn8";
export var progressTrack = "starter-profile-module--progressTrack--FGAaG";
export var questionBlock = "starter-profile-module--questionBlock--gnRwv";
export var questionTitle = "starter-profile-module--questionTitle--0K2ZV";
export var questions = "starter-profile-module--questions--1TG48";
export var saveButton = "starter-profile-module--saveButton--+nZ+7";
export var secondaryActions = "starter-profile-module--secondaryActions--9l3J9";
export var shell = "starter-profile-module--shell--jIOob";
export var stepDescription = "starter-profile-module--stepDescription--EE8zG";
export var stepLabel = "starter-profile-module--stepLabel--5lAb9";
export var stepTitle = "starter-profile-module--stepTitle--hbLnu";